const paths = {
  root: '/',
  about: '/about',
  features: '/features',
  solutions: '/solutions',
  resources: '/resources',
  pricing: '/pricing',
  support: '/support',
  terms: '/terms',
  privacy: '/privacy',
  me: '/me',
  auth: {
    signIn: `${process.env.NEXT_PUBLIC_APP_URL}/sign-in`,
    signUp: `${process.env.NEXT_PUBLIC_APP_URL}/sign-up`,
  },
} as const;

type PathConfig = typeof paths;

export { paths, type PathConfig };
